import { startTransition, Suspense, useId, useState } from "react";

import { loadOptions } from "~/utils/password";

import { FormControl } from "../FormControl";
import { PasswordInput } from "../PasswordInput";
import PasswordStrength from "./PasswordStrength";

export const StrongPasswordField: React.FC<
  Pick<React.ComponentProps<typeof FormControl>, "error" | "label">
> = ({ label = "Password", ...props }) => {
  const id = useId();
  const [value, setValue] = useState("");
  const [hasTyped, setHasTyped] = useState(false);
  const [optionsPromise] = useState(loadOptions());
  return (
    <div className="space-y-4">
      <FormControl id={id} label={label} {...props}>
        <PasswordInput
          required
          id={id}
          name="password"
          placeholder="Enter a strong password"
          autoComplete="new-password"
          value={value}
          onChange={async (event) => {
            if (!hasTyped) {
              startTransition(() => {
                setHasTyped(true);
              });
            }
            setValue(event.target.value);
          }}
        />
      </FormControl>
      <Suspense>
        {hasTyped && (
          <PasswordStrength promise={optionsPromise} value={value} />
        )}
      </Suspense>
    </div>
  );
};
